import { apiSlice } from 'api/apiSlice'
import { FeatureFlags } from 'shared/types'

/**
 * This API slice is used to fetch feature flags from the server.
 *
 * CloudFlare cache for this endpoint is set to BYPASS to always hit
 * our origin NextJS + Express server.
 */
const featuresApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeatures: builder.query<FeatureFlags, void>({
      query: () => {
        return {
          app: 'feature-flags',
          method: 'GET',
          url: `/web-api/v1/feature_flags`,
        }
      },
    }),
  }),
})

export const { useGetFeaturesQuery, useLazyGetFeaturesQuery } = featuresApi
